import React, { FC } from 'react'

import cn from 'classnames'

import classes from './offer-roundel.module.scss'
import { IMAGES_PATH } from '../../constants/globalStrings'

interface Voucher {
  code: string
  roundel_type?: string
}

interface OfferRoundelProps {
  voucher: Voucher | string
  roundelSide?: 'left' | 'right'
  roundelPosition?: 'left' | 'right' | 'topRight'
  isPlanCardSmall?: boolean
  usesYellowAssets?: boolean
}

export const OfferRoundel: FC<OfferRoundelProps> = ({
  voucher,
  roundelSide,
  roundelPosition,
  isPlanCardSmall,
  usesYellowAssets,
}) => {
  const { code, roundel_type } = voucher as Voucher

  let wrapperClass: string
  switch (roundelPosition) {
    case 'left': {
      wrapperClass = cn(classes.bottomLeftRoundelWrapper, {
        [classes.small]: isPlanCardSmall,
      })
      break
    }

    case 'right': {
      wrapperClass = classes.bottomRightRoundelWrapper
      break
    }

    // topRight
    default: {
      wrapperClass = classes.topRightRoundelWrapper
    }
  }

  let imageUrl: string
  if (roundel_type) {
    // Values get returned from Contentful with special characters and spaces so regex is to remove them (eg. 10% Off to 10-off)
    const type = roundel_type.replace(/[^A-Z0-9]+/gi, '-').toLowerCase()
    const suffix = usesYellowAssets ? 'yellow' : 'teal'
    // The images are named with the side of the arrow so need to flip the side
    imageUrl = `${IMAGES_PATH}/voucher-roundels/${type}-${
      roundelSide === 'right' ? 'left' : 'right'
    }-${suffix}.svg`
  } else {
    // This is the old format where roundels where uploaded for each voucher
    // Keeping it around for now until we're sure it's no longer used
    const suffix = usesYellowAssets ? '-yellow' : ''
    imageUrl = `${IMAGES_PATH}/voucher-roundels/${code}-${roundelSide}${suffix}.png`
  }

  return (
    <div className={wrapperClass}>
      <img
        className={classes.roundelImage}
        src={imageUrl}
        alt=""
        loading="lazy"
        data-testid="offer-roundel"
      />
    </div>
  )
}

export default OfferRoundel
